import React from 'react';
import * as Images from '../../assets';

const AboutUsPage = () => {
    return (
        <section id="about">
            <div className="text-center py-10 px-10 2xl:px-40 xl:px-40 l:px-40 md:px-20 sm:px-20 xs:px-20">
                <h1 className="text-3xl md:text-4xl font-bold mb-2">Smart Chokidar – The Resident's Trusted App</h1>
                <p className="text-gray-600 mb-8">Delightful moments build joyful communities—here's the app that's all about it!</p>
                <div className="flex flex-col text-start md:flex-row justify-center items-center md:space-x-8">
                    <div className="flex flex-col space-y-20 md:space-y-20">
                        <div className="flex items-start space-x-2">
                            <img src={Images.about_5} alt='Image 1' width='26px' height='26px' />
                            {/* <i className="fas fa-users text-green-500"></i> */}
                            <div>
                                <h2 className="font-bold">Secure Community Hub</h2>
                                <p className="text-gray-600">Connect with neighbors in conversations, forums, calls, and more</p>
                            </div>
                        </div>
                        <div className="flex items-start space-x-2">
                            <img src={Images.about_4} alt='Image 2' width='26px' height='26px' />
                            {/* <i className="fas fa-bullhorn text-yellow-500"></i> */}
                            <div>
                                <h2 className="font-bold">Stay Informed, Stay Organized</h2>
                                <p className="text-gray-600">Enjoy instant, ad-free access to crucial announcements and community guidelines</p>
                            </div>
                        </div>
                        <div className="flex items-start space-x-2">
                            <img src={Images.about_6} alt='Image 3' width='26px' height='26px' />
                            {/* <i className="fas fa-user-check text-orange-500"></i> */}
                            <div>
                                <h2 className="font-bold">Intelligent Visitor & Helper Management</h2>
                                <p className="text-gray-600">Effortlessly authorize visitors, greet guests, and monitor helper attendance—all from one location</p>
                            </div>
                        </div>
                    </div>
                    <div className="relative my-8 md:my-0">
                        <img
                            src={Images.about_us_img}
                            alt="Mobile app screenshot"
                            className="mx-auto h-100 object-contain"
                        />
                        {/* <img src={Images.about_us_img} alt="Overlay image" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" /> */}
                    </div>
                    <div className="flex flex-col space-y-20 md:space-y-20">
                        <div className="flex items-start space-x-2">
                            <img src={Images.about_3} alt='Image 4' width='26px' height='26px' />
                            {/* <i className="fas fa-search text-purple-500"></i> */}
                            <div>
                                <h2 className="font-bold">Forum</h2>
                                <p className="text-gray-600">Sell, give away, or trade items in your neighborhood—only for residents</p>
                            </div>
                        </div>
                        <div className="flex items-start space-x-2">
                            <img src={Images.about_2} alt='Image 5' width='26px' height='26px' />
                            {/* <i className="fas fa-exclamation-triangle text-pink-500"></i> */}
                            <div>
                                <h2 className="font-bold">Call to Guard</h2>
                                <p className="text-gray-600">Rapidly notify security or neighbors in case of assistance needed</p>
                            </div>
                        </div>
                        <div className="flex items-start space-x-2">
                            <img src={Images.about_1} alt='Image 6' width='26px' height='26px' />
                            {/* <i className="fas fa-calendar-alt text-blue-500"></i> */}
                            <div>
                                <h2 className="font-bold">Facilities & Events Made Easy</h2>
                                <p className="text-gray-600">Book shared facilities and remain current on community activities and events easily</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <p className="text-gray-600 mt-8">Join 13,00,000 Residents, across 3,500+ Housing Societies</p> */}
                {/* <div className="flex justify-center space-x-4 mt-8">
                    <a href="#contact">
                        <button className="about-us-btn text-white font-bold py-2 px-4 rounded-full">Get Started</button>
                    </a>
                </div> */}
            </div>
        </section>
    )
}

export default AboutUsPage